var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "quality-difference-box" }, [
    _c("div", { staticClass: "font-weight-bold" }, [
      _vm._v(_vm._s(_vm.translate("Check Quality Difference"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex gap-10px flex-column" }, [
      _c(
        "div",
        {
          staticClass: "quality-difference-btn",
          on: {
            click: function ($event) {
              return _vm.openComparePage()
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center gap-10px h-100" },
            [
              _c("div", { staticClass: "quality-difference-icon bg-main-1" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "18",
                      height: "19",
                      viewBox: "0 0 18 19",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M14.8588 1.11565C15.4496 1.50946 15.6103 2.30913 15.2165 2.89984L13.5448 5.39931H16.0724C16.7837 5.39931 17.3583 5.97395 17.3583 6.68521C17.3583 7.39647 16.7837 7.97111 16.0724 7.97111H11.833L9.26116 11.8288H16.0724C16.7837 11.8288 17.3583 12.4035 17.3583 13.1147C17.3583 13.826 16.7837 14.4006 16.0724 14.4006H7.54528L4.92526 18.3266C4.53145 18.9173 3.73178 19.0781 3.14107 18.6843C2.55036 18.2905 2.38962 17.4908 2.78343 16.9001L4.4551 14.4006H1.9275C1.21624 14.4006 0.641602 13.826 0.641602 13.1147C0.641602 12.4035 1.21624 11.8288 1.9275 11.8288H6.16696L8.73876 7.97111H1.9275C1.21624 7.97111 0.641602 7.39647 0.641602 6.68521C0.641602 5.97395 1.21624 5.39931 1.9275 5.39931H10.4546L13.0747 1.47329C13.4685 0.882578 14.2681 0.721841 14.8588 1.11565Z",
                        fill: "#E8EAED",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.translate("Calculate Quality Loss")) +
                    "\n        "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm._m(0),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("i", { staticClass: "far fa-arrow-right" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }